
import HeaderBar from "../../Users/common/HeaderBar";
import SideBar from "../../Users/common/SideBar";
import PeopleBodyPage from "./peopleBodyPage";
// import "./upload.css";


const PeoplePage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <PeopleBodyPage />
      </div>
    </main>
  );
};

export default PeoplePage;
